module.exports = __webpack_public_path__ + "static/media/mqa_logo.7d55a48f.png";